const BankIcon = ({
  className = 'trust-bank-icon',
  fill = '#4CB919',
  height = 22,
  width = 22,
  title = 'Trust Payment Page Icon'
}) => (
  <svg
    className={className}
    height={height}
    role='img'
    width={width}
    viewBox='0 0 36 36'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M8,32.4V13.8h8.2V32.4H8ZM18,5.2a2.3,2.3,0,1,1-2.3,2.3A2.3,2.3,0,0,1,18,5.2Zm9.9,8.6V32.4H19.8V13.8h8.1Zm3.6,18.5V13.8h2.8V10.2H31.5L18,0,4.4,10.2H1.7v3.6H4.4V32.4H0V36H36V32.4Z'
      fill={fill}
    ></path>
  </svg>
);

export default BankIcon;
